export enum LabOrderStatus {
  Created = 1,
  Submitted = 2,
  PartiallyResulted = 3,
  Resulted = 4,
  Completed = 5,
  Cancelled = 6,
}

export enum LabOrderIDEXXStatus { // dbo.LabOrderEventTypes
  Created = 1,
  Ordered = 2, // Submitted
  Resulted = 3,
  // PetParentResultNotification = 4, // Communicated
  // ReviewedByVeterinarian = 5,
  // ManuallyReconcilled = 6,
  Cancelled = 7,
}

export enum LabOrderTestResult {
  Positive,
  Negative,
  Inc,
}

export enum LabOrderTab {
  AllLabs = 'allLabs',
  ResultedLabs = 'resultedLabs',
}
